import type { TRuleWithTheme } from '@/styles/theme';

export const heading: TRuleWithTheme = () => ({
    marginBottom: '0.25rem',
});
